import {
  useInfiniteQuery,
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  GetHashtags200,
  GetHashtagsParams,
  GetTrendingHashtags200,
  GetTrendingHashtagsParams,
  SearchHashtags200,
  SearchHashtagsParams
} from './types'
import { customInstance } from '../custom-axios';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary Get trending hashtags
 */
export const getTrendingHashtags = (
    params?: GetTrendingHashtagsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetTrendingHashtags200>(
      {url: `https://api.ugot.uk/api/hashtags/trending`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetTrendingHashtagsQueryKey = (params?: GetTrendingHashtagsParams,) => {
    return [`https://api.ugot.uk/api/hashtags/trending`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTrendingHashtagsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getTrendingHashtags>>, TError = unknown>(params?: GetTrendingHashtagsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTrendingHashtags>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrendingHashtagsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrendingHashtags>>> = ({ signal }) => getTrendingHashtags(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTrendingHashtags>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTrendingHashtagsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getTrendingHashtags>>>
export type GetTrendingHashtagsInfiniteQueryError = unknown

/**
 * @summary Get trending hashtags
 */
export const useGetTrendingHashtagsInfinite = <TData = Awaited<ReturnType<typeof getTrendingHashtags>>, TError = unknown>(
 params?: GetTrendingHashtagsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTrendingHashtags>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTrendingHashtagsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetTrendingHashtagsQueryOptions = <TData = Awaited<ReturnType<typeof getTrendingHashtags>>, TError = unknown>(params?: GetTrendingHashtagsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTrendingHashtags>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrendingHashtagsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrendingHashtags>>> = ({ signal }) => getTrendingHashtags(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTrendingHashtags>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTrendingHashtagsQueryResult = NonNullable<Awaited<ReturnType<typeof getTrendingHashtags>>>
export type GetTrendingHashtagsQueryError = unknown

/**
 * @summary Get trending hashtags
 */
export const useGetTrendingHashtags = <TData = Awaited<ReturnType<typeof getTrendingHashtags>>, TError = unknown>(
 params?: GetTrendingHashtagsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTrendingHashtags>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTrendingHashtagsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Search hashtags
 */
export const searchHashtags = (
    params: SearchHashtagsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SearchHashtags200>(
      {url: `https://api.ugot.uk/api/hashtags/search`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getSearchHashtagsQueryKey = (params: SearchHashtagsParams,) => {
    return [`https://api.ugot.uk/api/hashtags/search`, ...(params ? [params]: [])] as const;
    }

    
export const getSearchHashtagsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof searchHashtags>>, TError = unknown>(params: SearchHashtagsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchHashtags>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchHashtagsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchHashtags>>> = ({ signal }) => searchHashtags(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchHashtags>>, TError, TData> & { queryKey: QueryKey }
}

export type SearchHashtagsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof searchHashtags>>>
export type SearchHashtagsInfiniteQueryError = unknown

/**
 * @summary Search hashtags
 */
export const useSearchHashtagsInfinite = <TData = Awaited<ReturnType<typeof searchHashtags>>, TError = unknown>(
 params: SearchHashtagsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchHashtags>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSearchHashtagsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSearchHashtagsQueryOptions = <TData = Awaited<ReturnType<typeof searchHashtags>>, TError = unknown>(params: SearchHashtagsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchHashtags>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchHashtagsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchHashtags>>> = ({ signal }) => searchHashtags(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchHashtags>>, TError, TData> & { queryKey: QueryKey }
}

export type SearchHashtagsQueryResult = NonNullable<Awaited<ReturnType<typeof searchHashtags>>>
export type SearchHashtagsQueryError = unknown

/**
 * @summary Search hashtags
 */
export const useSearchHashtags = <TData = Awaited<ReturnType<typeof searchHashtags>>, TError = unknown>(
 params: SearchHashtagsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchHashtags>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSearchHashtagsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get hashtags (for autocomplete)
 */
export const getHashtags = (
    params?: GetHashtagsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetHashtags200>(
      {url: `https://api.ugot.uk/api/hashtags`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetHashtagsQueryKey = (params?: GetHashtagsParams,) => {
    return [`https://api.ugot.uk/api/hashtags`, ...(params ? [params]: [])] as const;
    }

    
export const getGetHashtagsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getHashtags>>, TError = unknown>(params?: GetHashtagsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getHashtags>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHashtagsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHashtags>>> = ({ signal }) => getHashtags(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getHashtags>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHashtagsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getHashtags>>>
export type GetHashtagsInfiniteQueryError = unknown

/**
 * @summary Get hashtags (for autocomplete)
 */
export const useGetHashtagsInfinite = <TData = Awaited<ReturnType<typeof getHashtags>>, TError = unknown>(
 params?: GetHashtagsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getHashtags>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHashtagsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetHashtagsQueryOptions = <TData = Awaited<ReturnType<typeof getHashtags>>, TError = unknown>(params?: GetHashtagsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHashtags>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHashtagsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHashtags>>> = ({ signal }) => getHashtags(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHashtags>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHashtagsQueryResult = NonNullable<Awaited<ReturnType<typeof getHashtags>>>
export type GetHashtagsQueryError = unknown

/**
 * @summary Get hashtags (for autocomplete)
 */
export const useGetHashtags = <TData = Awaited<ReturnType<typeof getHashtags>>, TError = unknown>(
 params?: GetHashtagsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHashtags>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHashtagsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



